import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';
import type { LmdbPostRequestBody } from '../models/lmdb-admin-request.model';

/**
 * Optional HTTP get implementation for LMDB admin API.
 * When provided by the host app, LMDB requests use this (e.g. via HttpClientService with custom base URL)
 * so they go through the app's wrapper (interceptors, loader, auth). When not provided, the lib uses
 * HttpClient with the selected server's apiBaseUrl.
 */
export const LMDB_HTTP_GET = new InjectionToken<
  (path: string, baseUrl: string) => Observable<unknown>
>('LMDB_HTTP_GET');

/**
 * Optional HTTP post implementation for LMDB admin API.
 * When provided by the host app, LMDB POST requests use this (e.g. via HttpClientService with custom base URL).
 */
export const LMDB_HTTP_POST = new InjectionToken<
  (path: string, baseUrl: string, body: LmdbPostRequestBody) => Observable<object>
>('LMDB_HTTP_POST');
